module.exports = __webpack_public_path__ + "img/school1.2ac4ef21.jpg";